import { AppBar, Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Menu, MenuItem, Sidebar, SubMenu, useProSidebar } from "react-pro-sidebar";
import * as api from '../pages/services/api'
import Loader from '../components/Loader'
import logo from "../assets/icons/logo.svg";
// import open from "../assets/icons/openSidebar.svg";
import open from "../assets/icons/openSidebar.png";

import { useNavigate } from "react-router-dom";
import LogoutIcon from '@mui/icons-material/Logout';
import { useDispatch, useSelector } from "react-redux";
import { menuActive as manageMenu } from '../store/menuSlice'
import { login, logout as logout_reduce, user_data } from '../store/authSlice'

// import icon_profile_active from '../assets/icons/profile_green.svg'
// import icon_profile_inactive from '../assets/icons/profile.svg'

// import icon_menu_home_active from '../assets/icons/menu/home_active.svg'
// import icon_menu_home_inactive from '../assets/icons/menu/home_inactive.svg'

// import icon_menu_dashboard_active from '../assets/icons/menu/dashboard_active.svg'
// import icon_menu_dashboard_inactive from '../assets/icons/menu/dashboard_inactive.svg'

// import icon_menu_health_active from '../assets/icons/menu/health_active.svg'
// import icon_menu_health_inactive from '../assets/icons/menu/health_inactive.svg'

// import icon_menu_e_active from '../assets/icons/menu/learn_active.svg'
// import icon_menu_e_inactive from '../assets/icons/menu/learn_inactive.svg'

// import icon_menu_manage_active from '../assets/icons/menu/manage_active.svg'
// import icon_menu_manage_inactive from '../assets/icons/menu/manage_inactive.svg'

// import icon_menu_import_active from '../assets/icons/menu/import_active.svg'
// import icon_menu_import_inactive from '../assets/icons/menu/import_inactive.svg'

// import icon_menu_summary_active from '../assets/icons/menu/summary_active.svg'
// import icon_menu_summary_inactive from '../assets/icons/menu/summary_inactive.svg'

// import icon_menu_eval_active from '../assets/icons/menu/evaluation_active.svg'
// import icon_menu_eval_inactive from '../assets/icons/menu/evaluation_inactive.svg'

// import icon_menu_log_active from '../assets/icons/menu/log_active.svg'
// import icon_menu_log_inactive from '../assets/icons/menu/log_inactive.svg'

// import icon_menu_work_active from '../assets/icons/menu/work_active.svg'
// import icon_menu_work_inactive from '../assets/icons/menu/work_inactive.svg'

// import icon_menu_contact_active from '../assets/icons/menu/contact_active.svg'
// import icon_menu_contact_inactive from '../assets/icons/menu/contact_inactive.svg'


function SideNav() {

  const menuActive = useSelector((state) => state.menu_active)
  const auth = useSelector((state) => state.auth.user_data)
  const dispatch = useDispatch()
  const { broken, collapseSidebar, toggleSidebar } = useProSidebar();

  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [menu, setMenu] = useState([])

  const [userData, setUserData] = useState()

  const [toggle, setToggle] = useState(false)

  useEffect(() => {
    // getProfile()
    setMenu(auth?.permission?.menu_list)
    setUserData(auth)
  }, [auth])

  const handleMenuClick = (menu, path) => {
    navigate(path)
    dispatch(manageMenu(menu))
  }

  const logout = async () => {
    setLoading(true)
    let res = await api.logout()
    setLoading(false)
    if (res) {
      if (res['data']['code'] == 200) {
        dispatch(logout_reduce())
        localStorage.clear()
      } else if (res['data']['code'] === 204) {
        dispatch(logout_reduce())
        localStorage.clear()
      } else {
        //alert(res['data']['message'])
      }
    } else {
      alert('ไม่ตอบสนอง')
    }
  }

  const getProfile = async () => {
    setLoading(true)
    let res = await api.profile()
    setLoading(false)
    if (res) {
      if (res['data']['code'] === 200) {
        let { data } = res.data
        let { permission } = data
        setMenu(permission?.menu_list)
        setUserData(data)
      } else if (res['data']['code'] === 401) {
        refreshToken()
      } else {
        //alert(res['data']['message'])
      }
    } else {
      alert('ไม่ตอบสนอง')
    }
  }

  const refreshToken = async () => {
    setLoading(true)
    let res = await api.refreshToken()
    setLoading(false)
    if (res) {
      if (res['data']['code'] === 200) {
        dispatch(login(res['data']['data']))
        localStorage.setItem('AccessToken', res['data']['data']['access_token'])
        localStorage.setItem('RefreshToken', res['data']['data']['refresh_token'])

        await getProfile()
      } else if (res['data']['code'] === 204) {
        dispatch(logout_reduce())
        localStorage.clear()
      } else {
        //alert(res['data']['message'])
      }
    } else {
      //alert(res['data']['message'])
    }
  }

  const handle = () => {
    setToggle(!toggle)
    broken ? toggleSidebar() : collapseSidebar()
  }

  return (
    <>
      <Loader loading={loading} />

      <div style={{ display: 'flex' }}>

        <Sidebar
          style={{
            height: "100vh",
            top: "auto"
          }}
          breakPoint="md"
          backgroundColor={"#FFFFFF"}
        >
          <Menu
            menuItemStyles={{
              button: ({ active }) => {
                return {
                  backgroundColor: active ? "transparent" : "transparent",
                  color: active ? '#478F96' : '#9D9B9B',
                  fontWeight: active ? 'bold' : 'normal',
                  borderRadius: "0.5rem",
                  margin: "0.15rem",
                  transition: "background-color 0.3s ease",
                };
              },
            }}
          >

            <MenuItem icon={<img style={{ width: "40px" }} src={logo} alt="" />} >
              <p>ระบบข้อมูลสุขภาพ</p>
              <p>กำลังพล สป.</p>
            </MenuItem>

            <hr style={{ border: '1px solid #EBEFF2', margin: '5px 10px' }} />

            {menu?.map((item, index) => (
              <React.Fragment key={index}>
                {item['subMenu'] === true ?
                  <SubMenu
                    onClick={() => dispatch(manageMenu(item['menu']))}
                    active={menuActive.menu === item['menu']}
                    defaultOpen={false}
                    label={item['menu']}
                    icon={<img src={menuActive.menu === item['menu'] ? item['icon_active'] : item['icon_inactive']} alt="" />}
                  >
                    <Menu
                      menuItemStyles={{
                        button: ({ active }) => {
                          return {
                            backgroundColor: active ? "#DAE9EA" : "transparent",
                            color: active ? '#478F96' : '#AEB4DD',
                            fontWeight: active ? 'bold' : 'normal',
                            borderRadius: "0.5rem",
                            margin: "0.15rem",
                            transition: "background-color 0.3s ease",
                          }
                        }
                      }}
                    >
                      {item['subList'].map((i, idx) => (
                        <MenuItem key={idx}
                          onClick={() => { handleMenuClick(i['menu'], i['path']) }}
                          active={menuActive.menu === i['menu']}
                          icon={toggle ? '' : <img src="" />}
                        >
                          <p>{i['menu'] === 'จัดการเกณฑ์แปรผล' ? 'จัดการเกณฑ์แปลผล' : i['menu']}</p>
                        </MenuItem>
                      ))}
                    </Menu>
                  </SubMenu>
                  :
                  <MenuItem
                    active={menuActive.menu === item['menu']}
                    icon={<img src={menuActive.menu === item['menu'] ? item['icon_active'] : item['icon_inactive']} alt="" />}
                    onClick={() => handleMenuClick(item['menu'], item['path'])}
                  >
                    <p>{item['menu']}</p>
                  </MenuItem>
                }
              </React.Fragment>
            ))}

            <hr style={{ border: '1px solid #EBEFF2', margin: '5px 10px' }} />

            <MenuItem
              active={menuActive.menu === 'บัญชีผู้ใช้'}
              icon={<img
                style={{ width: '40px', height: '40px', borderRadius: '50%', }}
                src={
                  userData?.['image_url'] ?
                    userData['image_url']
                    :
                    menuActive.menu === 'บัญชีผู้ใช้' ? `/assets/icons/profile_green.svg` : `/assets/icons/profile.svg`
                }
                alt=""
              />}
              onClick={() => handleMenuClick('บัญชีผู้ใช้', '/profile')}
            >
              <p style={{ color: '#192A3E', fontWeight: 600 }}>{userData?.['titlename']} {userData?.['firstname']} {userData?.['lastname']}</p>
              <p style={{ fontSize: '14px' }}>บัญชีผู้ใช้</p>
            </MenuItem>

            <MenuItem
              icon={<LogoutIcon sx={{ color: "#9D9B9B" }} />}
              onClick={() => { logout() }}
            >
              <p>ออกจากระบบ</p>
            </MenuItem>

          </Menu>
        </Sidebar>

        <AppBar sx={{ height: 0 }} >
          <img
            style={{ width: '20px' }}
            src={open}
            onClick={() => (handle())}
          />
        </AppBar>

      </div>

    </>
  );
}

export default SideNav;
